import { EmployeeProfileOrganizationalAssignmentSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/organizationalAssignment/employeeProfile.organizationalAssignment.translation.pl.ts';

export const employeeProfileOrganizationalAssignmentSectionTranslation: EmployeeProfileOrganizationalAssignmentSectionTranslation =
  {
    content: {
      left: {
        company: 'Company',
        functionalArea: 'Functional Area',
        grade: 'Grade',
        organizationUnit: 'Organization Unit',
        positionSeniority: 'Seniority in Position',
        region: 'Region',
        workSeniority: 'Seniority in JMP',
        zone: 'Zone',
      },
      right: {
        employmentHistory: 'Employment History',
        notFound: 'No employment history found',
      },
    },
    headerTitle: 'Organizational Assignments',
    headerTitleShorter: 'Organizational Assignments',
  };
